import { render } from "./Dbs.vue?vue&type=template&id=c17afbb2&scoped=true"
import script from "./Dbs.vue?vue&type=script&lang=js"
export * from "./Dbs.vue?vue&type=script&lang=js"

import "./Dbs.vue?vue&type=style&index=0&id=c17afbb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17afbb2"]])

export default __exports__